import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLifecycles } from 'react-use';

import { LessonSocket } from 'common.components/lesson-socket/lesson-socket';
import LessonView from 'common.components/lesson-view.index/lesson-view';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { resultsActions } from 'common.components/results/actions';
import LessonResults from 'common.components/results/results';
import { SpecCourseLessonViewSectionContent } from 'common.components/spec-course-lesson-view/__section-content/spec-course-lesson-view__section-content';
import { SpecCourseLessonViewSectionDescription } from 'common.components/spec-course-lesson-view/__section-description/spec-course-lesson-view__section-description';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';
import { actions as problemsViewActions } from 'store/problems-view/actions';
import { stickersActions } from 'store/stickers/actions';

import { SpecCourseResultsTitle } from '../__title/results__title';

import './results__table.scss';

interface Props {
    descriptionId: string | null;
}

export const SpecCourseLessonViewResultsTable = ({ descriptionId }: Props) => {
    const shouldConnectToSocket = useSelector(lessonSelectors.getCanLessonResultBeChanged);
    const dispatch = useDispatch();

    useLifecycles(
        () => {
            dispatch(stickersActions.resetClessonMetaStickers());
            dispatch(resultsActions.updateLessonStats());
        },
        () => {
            dispatch(resultsActions.clearState());
        }
    );

    const handleHeaderCardClick = useCallback(
        (problemId: number) => {
            dispatch(lessonViewActions.toggleModal(true));
            dispatch(lessonViewActions.setIsHeadless(true));
            dispatch(problemsViewActions.setSelectedProblemId(problemId));
        },
        [dispatch]
    );

    const handleStudentNameClick = useCallback(
        (studentId: number) => {
            dispatch(lessonViewActions.toggleModal(true));
            dispatch(lessonViewActions.setIsHeadless(true));
            dispatch(lessonViewActions.setSelectedStudentId(studentId));
        },
        [dispatch]
    );

    const handleCloseLessonModal = useCallback(() => {
        dispatch(lessonViewActions.toggleModal(false));
    }, [dispatch]);

    return (
        <>
            <SpecCourseLessonViewSection mix="spec-course-results__view-section">
                <SpecCourseResultsTitle />
                <SpecCourseLessonViewSectionDescription id={descriptionId} />
                <SpecCourseLessonViewSectionContent mix="spec-course-results__section-content-table">
                    <LessonResults
                        mix="spec-course-results__table"
                        onHeaderCardClick={handleHeaderCardClick}
                        onStudentNameClick={handleStudentNameClick}
                        showHelp={false}
                    />
                </SpecCourseLessonViewSectionContent>
            </SpecCourseLessonViewSection>
            {shouldConnectToSocket && <LessonSocket />}
            <LessonView onClose={handleCloseLessonModal} shouldCloseOnGoBack={true} />
        </>
    );
};
